import { render } from "./App.vue?vue&type=template&id=7586dcdb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7586dcdb&lang=scss"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web_jinmixi-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__